export default __webpack_public_path__ + "static/media/flag-fr.10ee6efb.svg";